import React, { useState, useEffect } from 'react'
import { NewFailureCounterChart } from './NewFailureCounterChart'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { useTranslations } from '@/hooks/useTranslations'
import { SearchCriteria, SearchCriteriaParams } from '@/pages/communal/statistics/components/common/searchCriteria'
import { mapBuckets } from '../common/labels'
import { HelpPopupButton } from '@/popups/helppopup/help'
import { useModal } from '@/components/modal/Modal'
import { FailureCounterPopupBody } from './FailureCounterPopup'

type NewFailureCounterBoxProps = { 
  services: Services
  session: CurrentSession
  criteria: SearchCriteria
  goToMachinePage: (machineId: string) => void
}

// Interface representing a single data entry
export interface NewFailureCounterData {
  bucket: string     // ISO timestamp string
  failureCount: number // number of failure devices
}

// Interface representing the full API response (array of entries)
export type NewFailureCounterResponse = NewFailureCounterData[]

export const NewFailureCounterBox = ({ services, session, criteria, goToMachinePage }: NewFailureCounterBoxProps) => {
  const translates = useTranslations(services, session)
  const { openModal } = useModal()
  const [response, setResponse] = useState<NewFailureCounterResponse>()

  useEffect(() => {
    setResponse(undefined)
    services.session
      .fetchWithToken(`/api/communal/statistics/machines/machine/newfailurecounter?${SearchCriteriaParams(criteria)}`)
      .then((r) => r.json())
      .then((data) => {
        setResponse(data)
      })
  }, [services.session, criteria])

  if (translates === undefined || !response) {
    return <div className='spinner'></div>
  }

  // Prepare labels and data for the chart
  const labels = response.map(mapBuckets)
  const failureCounts = response.map(row => row.failureCount)

  return (
    <div>
      <HelpPopupButton helpKey='page.dashboard.global.box.machine_newfailurecounter.help' translates={translates}/>
      <NewFailureCounterChart
        labels={labels}
        dataSet={failureCounts}
        chartTitle={translates.for('page.dashboard.global.box.machine_newfailurecounter.title')}
        dataLabel={translates.for('page.dashboard.global.box.machine_newfailurecounter.data_label')}
        onClick={(i) => openModal((props) => FailureCounterPopupBody({
          ...props,
          services,
          session,
          criteria,
          bucketFor: new Date(response[i].bucket),
          goToMachinePage,
          endpoint: 'new-failures'
        }))}
      />
    </div>
  )
}
